/**
 * @module actions/messages
 */
import axios from 'axios'
import { API_URL, FILE_STORAGE_API } from '../constants'

/**
 * @description Get message by id
 * @return {Promise} Axios promise
 */
export function getMessage (id) {
  let url = API_URL + '/Message/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Post update / insert message to api
 * @return {Promise} Axios promise
 */
export function createUpdateMessage (data) {
  let url = API_URL + '/Message/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description delete message to api
 * @return {Promise} Axios promise
 */
export function deleteMessage (id) {
  let url = API_URL + '/Message/Delete/' + id
  return dispatch => {
    return axios.post(url)
  }
}

/**
 * @description Get all chain messages from api
 * @return {Promise} Axios promise
 */
export function getMessageChain (id) {
  let url = API_URL + '/Message/GetChain/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get all company messages by id from api
 * @return {Promise} Axios promise
 */
export function getMessageCompany (id) {
  let url = API_URL + '/Message/GetCompany/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Upload file
 * @return ..
 */
export function fileUpload (file, type) {
  let url = FILE_STORAGE_API + '/fileservice/upload?orderID=0'
  let data = new window.FormData()
  data.append(file.name, file)
  if (typeof type !== 'undefined') {
    data.append('Type', type)
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Delete file
 * @return ..
 */
export function fileDelete (data) {
  let url = FILE_STORAGE_API + '/FileService/Delete'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Update news show status
 * @return ..
 */
export function updateNewsShowStatus (data) {
  let url = FILE_STORAGE_API + '/Message/UpdateShowStatus/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/messages.js